import { useApi, useTranslation } from '@zurich/common/hooks';
import { deleteVSGAPhoto } from '~/lib/api/documents/deleteVSGAPhoto';

export function useDeleteVSGAPhoto() {
  const { t } = useTranslation();

  return useApi({
    request: deleteVSGAPhoto,
    options: {
      errorText: t('vsga:deleteVSGAPhotoEndpoint.error'),
      successText: t('vsga:deleteVSGAPhotoEndpoint.success'),
    },
  });
}
